import { IonIcon } from '@ionic/react';
import { checkmarkCircle, time, alertCircle } from 'ionicons/icons';
import type { ProfessionalAssociationMembership } from '@/types';

interface MembershipVerificationStatusProps {
  membership: ProfessionalAssociationMembership;
}

const STATUS_CONFIG = {
  Verified: { icon: checkmarkCircle, color: 'var(--bp-success, #22c55e)', label: 'Verified' },
  Pending: { icon: time, color: 'var(--bp-warning, #f59e0b)', label: 'Pending verification' },
  UnableToVerify: { icon: alertCircle, color: 'var(--bp-error, #ef4444)', label: 'Unable to verify' },
  Rejected: { icon: alertCircle, color: 'var(--bp-error, #ef4444)', label: 'Verification rejected' },
  Expired: { icon: alertCircle, color: 'var(--bp-text-muted, #64748b)', label: 'Verification expired' },
} as const;

export function MembershipVerificationStatus({ membership }: MembershipVerificationStatusProps) {
  const verificationResult = membership.verification?.verificationResult;
  if (!verificationResult || verificationResult === 'Pending') {
    if (!membership.verified) return null;
  }

  const config = verificationResult
    ? STATUS_CONFIG[verificationResult as keyof typeof STATUS_CONFIG] ?? STATUS_CONFIG.Pending
    : membership.verified
      ? STATUS_CONFIG.Verified
      : null;

  if (!config) return null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6,
      padding: '6px 10px', borderRadius: 8,
      background: `${config.color}10`,
      border: `1px solid ${config.color}30`,
    }}>
      <IonIcon icon={config.icon} style={{ fontSize: '0.9rem', color: config.color }} />
      <div>
        <div style={{ fontSize: '0.75rem', fontWeight: 500, color: config.color }}>
          {config.label}
        </div>
        {membership.verification?.verificationDate && (
          <div style={{ fontSize: '0.65rem', color: 'var(--bp-text-muted, #64748b)' }}>
            {membership.verification.verificationDate}
          </div>
        )}
      </div>
    </div>
  );
}
